import { useEffect } from 'react'
import { keycloak, LOGIN_OPTIONS } from './keycloak'

/**
 * Onboarding landing page. Admin invite emails (UPDATE_PASSWORD) link here.
 * Mounting it immediately starts an app-initiated auth request, so Keycloak runs
 * the required "set password" action inside the flow and auto-redirects back into
 * the app with a token — no info-page dead-end, no second login click.
 */
export function Welcome() {
  useEffect(() => {
    keycloak.login(LOGIN_OPTIONS)
  }, [])

  return <p className="p-6 text-sm text-gray-600">Redirecting to sign in…</p>
}
